import {isUndefined, merge} from 'lodash';
import Assessment from '../assessment.js';
import AssessmentResult from '../../../values/AssessmentResult.js';
import {SINGLE_TITLE_ID, TECHNICAL_SEO_POINTS} from '@axyseo/const/analysis';

/**
 * Assessment to check whether the body of the text contains more than 1 H1s in the body.
 * This assessment doesn't penalize H1 that is not in the very beginning of the body.
 */
class SingleTitleAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} config The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: SINGLE_TITLE_ID,
      docUrl: 'https://help.seoon.io/seo/seo-checklist',
      ctaType: 'contactUs',
      priority: 'high',
      title: 'Duplicate title',
      content: {
        improve: '',
        bad: 'Found duplicate titles. Check your content and create unique titles.',
        good: 'No duplicate titles found.'
      }
    };

    this.identifier = SINGLE_TITLE_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the h1 research and based on this returns an assessment result with a score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling the research.
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    if (!isUndefined(calculatedResult)) {
      assessmentResult.setScore(calculatedResult.score);
      assessmentResult.setStatus(calculatedResult.status);
    }

    return assessmentResult;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string}}
   */
  calculateResult(paper) {
    const count = paper.getTitleCount();

    let status = 'bad';
    if (count === 1) {
      status = 'good';
    }

    const score = this.getScore(TECHNICAL_SEO_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   * Checks whether the paper has a text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns {boolean} True when there is text.
   */
  isApplicable(paper) {
    return true;
  }
}

export default SingleTitleAssessment;
